import { render, staticRenderFns } from "./RssForm.vue?vue&type=template&id=2095e424&scoped=true&"
import script from "./RssForm.vue?vue&type=script&lang=ts&"
export * from "./RssForm.vue?vue&type=script&lang=ts&"
import style0 from "./RssForm.vue?vue&type=style&index=0&id=2095e424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2095e424",
  null
  
)

export default component.exports